const initialState = {
    countrylist: [],
    dataview2:[],
  };
  
  const Orgcounrtry = (state = initialState, action: any) => {
    switch (action.type) {
      case 'FETCH_DATA_SUCCESS':
        return { ...state, countrylist: action.payload };
      case 'FETCH_DATA_SEARCH2_SUCCESS':
          return{ ...state, dataview2: action.payload }
      default:
        return state;
    }
  };
  
  export default Orgcounrtry;
  
  